function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { arrow, autoUpdate, flip, offset, safePolygon, shift, useClick, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole } from '@floating-ui/react';
import React from 'react';
import { getThemeSpacingAsNumber } from '../../../theme/foundations/spaces';
var closeDelay = 500;
export var horizontalPlacementEdges = ['left-start', 'right-start', 'left-end', 'right-end'];
export var verticalPlacementEdges = ['top-start', 'bottom-start', 'top-end', 'bottom-end'];
export var edgesPlacements = [...horizontalPlacementEdges, ...verticalPlacementEdges];
export var usePopover = _ref => {
  var {
    triggerEvent = 'hover',
    defaultIsOpen = false,
    placement,
    isOpen: controlledOpen,
    onOpenChange: setControlledOpen,
    arrowRef,
    showArrow,
    enableAnimationFrame = false
  } = _ref;
  var [uncontrolledOpen, setUncontrolledOpen] = React.useState(defaultIsOpen);
  var [descriptionId, setDescriptionId] = React.useState();
  var isOpen = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;

  var setIsOpen = (open, triggerEvent) => {
    if (setControlledOpen) {
      setControlledOpen(open, triggerEvent);
      return;
    }

    setUncontrolledOpen(open);
  };

  var defaultOffset = getThemeSpacingAsNumber('xs');
  var mainAxis = showArrow ? defaultOffset * 2 : defaultOffset;
  var alignmentAxis = showArrow ? getThemeSpacingAsNumber('s') : 0;
  var sharedMiddleware = [offset({
    mainAxis,
    alignmentAxis: -alignmentAxis
  }), flip(), shift({
    padding: getThemeSpacingAsNumber('m')
  })];
  var data = useFloating({
    placement,
    open: isOpen,
    onOpenChange: open => setIsOpen(open, 'outside'),
    whileElementsMounted: (reference, floating, update) => autoUpdate(reference, floating, update, {
      animationFrame: enableAnimationFrame
    }),
    middleware: arrowRef ? [...sharedMiddleware, arrow({
      element: arrowRef
    })] : sharedMiddleware
  });
  var {
    context
  } = data;
  var triggeredByClick = triggerEvent === 'click';
  var triggeredByHover = triggerEvent === 'hover';
  var hover = useHover(context, {
    enabled: triggeredByHover,
    handleClose: safePolygon(),
    delay: {
      close: closeDelay
    }
  });
  var focus = useFocus(context, {
    enabled: triggeredByHover
  });
  var click = useClick(context, {
    enabled: triggeredByClick && !controlledOpen
  });
  var dismiss = useDismiss(context);
  var role = useRole(context);
  var interactions = useInteractions([hover, focus, click, dismiss, role]);
  return _objectSpread(_objectSpread(_objectSpread({
    isOpen,
    setIsOpen,
    triggeredByClick
  }, interactions), data), {}, {
    descriptionId,
    setDescriptionId
  });
};
export var PopoverContext = /*#__PURE__*/React.createContext(null);
export var usePopoverContext = () => {
  var context = React.useContext(PopoverContext);

  if (context === null) {
    throw new Error('BasePopover components must be wrapped in <BasePopover />');
  }

  return context;
};
//# sourceMappingURL=basePopover.utils.js.map